import React, { useState, useEffect } from 'react'
import { Button, Header, Modal, Icon, } from 'semantic-ui-react'
import { useStore } from 'src/stores/store'
import { observer } from 'mobx-react-lite';
import parse from 'html-react-parser';
import * as KeyNames from 'src/utils/KeyNames'
import ApiAgent from "src/api/ApiAgent";
import { toast } from 'react-toastify';
import { runInAction } from 'mobx';

const AlertDialog = () => {

  const {userStore, commonStore} = useStore();
  const [addButtonWaiting, setAddButtonWaiting] = React.useState(false);
  const [transactionDone, setTransactionDone] = React.useState(false);

  const onHandleCloseButton = () => {
    commonStore.setAlertMsgOpen(false);
  };

  const onHandleLogoutClick = () => {

    commonStore.setAlertMsgOpen(false);

    // Save current web version to local storage...
    window.localStorage.setItem(KeyNames.ApplicationVersion, userStore.webVersion);

    userStore.logout();
  }

  const onHandleReloadClick = () => {

    // Save current web version to local storage...
    window.localStorage.setItem(KeyNames.ApplicationVersion, userStore.webVersion);

    // Delete caches...
    if ('caches' in window) {
      caches.keys().then((names) => {
          names.forEach(async (name) => {
              await caches.delete(name)
          })
      });
    }

    window.location.reload( true );
  }


  const onHandleReportErrorClick = () => {

    addReportErrorAsync();
  }

  const addReportErrorAsync = async () => {

    const request = { Title: commonStore.alertMsg.title,
                    Message: "LoginAccount: " + JSON.stringify(userStore.loginAccount) +
                    "<br /><br />AlertMsg: " + JSON.stringify(commonStore.alertMsg.message) +
                    "<br /><br />Request: " + JSON.stringify(userStore.lastRequestBody)
    }

    setAddButtonWaiting( true );

    try {

      const response = await ApiAgent.ReportError.notifyReportError( request );
      runInAction(() => {

        if (response) {

          if (response.isSuccess) {

            toast.success("Report Error notified successfully");
            setTransactionDone( true );
          }
          else {
            toast.error("Fail to notify Report Error, <br />" + response.showMessage);
          }
        }
      })
    }
    catch(error) {
      console.log(error);
    }
    finally {
      setAddButtonWaiting( false );
    }
  }

  const isOpenDialog = commonStore.alertMsg.isOpen;
  const isSuccess = commonStore.alertMsg.isSuccess;
  const isReload = commonStore.alertMsg.isReload;
  
  return (
    <>
      <Modal
        closeIcon={{ style: { top: '1rem', right: '1rem' }, color: 'black', name: 'close' }}
        open={isOpenDialog}
        onClose={onHandleCloseButton}
        size={"small"}
        style={{zIndex: "1500", margin: "auto"}}
      >
        <Header className='alert-dialog-header'>
          <Icon name={isSuccess ? 'check' : 'exclamation circle'} color={isSuccess ? 'green' : 'red'} />
          <Header.Content>{commonStore.alertMsg.title}</Header.Content>
        </Header>
        <Modal.Content>
          <Modal.Description>
            {commonStore.alertMsg.message ? parse(commonStore.alertMsg.message) : ""}
			
			      { (commonStore.alertMsg.title === "Bad Request" || commonStore.alertMsg.title === "Internal Server Error") && 
              <div style={{marginTop: 10}}>
                A communication error was encountered. <br />Please click the ‘Report Error’ button to email the issue to us. 
              </div>
            }
          </Modal.Description>
        </Modal.Content>

        <Modal.Actions>

          { (commonStore.alertMsg.title === "Bad Request" || commonStore.alertMsg.title === "Internal Server Error") && 
            <>
              <Button color='red' onClick={onHandleReportErrorClick} 
                disabled={transactionDone} loading={addButtonWaiting}>
                <Icon name='bullhorn' />REPORT ERROR
              </Button>
            </>
          }

          
          { isReload && 
            <Button color='teal' onClick={onHandleReloadClick}>
              <Icon name='refresh' />RELOAD
            </Button>
          }
          <Button color='yellow' onClick={onHandleCloseButton}>
            <Icon name='close' />CLOSE
          </Button>
        </Modal.Actions>
      </Modal>
    </>
  ) 
}

export default observer(AlertDialog)


